var _path, _circle, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyGifdark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 85,
    viewBox: "0 0 150 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.713 11C147.185 11 150 13.8247 150 17.3091C150 20.7935 147.185 23.6181 143.713 23.6181H107.784C111.257 23.6181 114.072 26.4428 114.072 29.9272C114.072 33.4116 111.257 36.2363 107.784 36.2363H127.545C131.017 36.2363 133.832 39.0609 133.832 42.5453C133.832 46.0298 131.017 48.8544 127.545 48.8544H118.407C114.028 48.8544 110.479 51.6791 110.479 55.1635C110.479 57.4864 112.275 59.5894 115.868 61.4726C119.341 61.4726 122.156 64.2972 122.156 67.7816C122.156 71.266 119.341 74.0907 115.868 74.0907H41.3174C37.8449 74.0907 35.0299 71.266 35.0299 67.7816C35.0299 64.2972 37.8449 61.4726 41.3174 61.4726H6.28743C2.81498 61.4726 0 58.6479 0 55.1635C0 51.6791 2.81498 48.8544 6.28743 48.8544H42.2156C45.688 48.8544 48.503 46.0298 48.503 42.5453C48.503 39.0609 45.688 36.2363 42.2156 36.2363H19.7605C16.288 36.2363 13.4731 33.4116 13.4731 29.9272C13.4731 26.4428 16.288 23.6181 19.7605 23.6181H55.6886C52.2162 23.6181 49.4012 20.7935 49.4012 17.3091C49.4012 13.8247 52.2162 11 55.6886 11H143.713ZM143.713 36.2363C147.185 36.2363 150 39.0609 150 42.5453C150 46.0298 147.185 48.8544 143.713 48.8544C140.24 48.8544 137.425 46.0298 137.425 42.5453C137.425 39.0609 140.24 36.2363 143.713 36.2363Z",
    fill: "#2B2E31"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 69.5,
    r: 4.5,
    fill: "#2B2E31"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.9618,
    cy: 35.7043,
    rx: 24.9657,
    ry: 25.0514,
    fill: "#BFC4CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8522 39.0477C59.2739 39.0477 60.4769 37.8406 60.4769 36.4141C60.4769 34.9875 59.2739 33.7804 57.8522 33.7804C56.4305 33.7804 55.2275 34.9875 55.2275 36.4141C55.2275 37.8406 56.4305 39.0477 57.8522 39.0477Z",
    fill: "#91979D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9752 39.0476C79.3969 39.0476 80.5999 37.8405 80.5999 36.414C80.5999 34.9874 79.3969 33.7803 77.9752 33.7803C76.5535 33.7803 75.3506 34.9874 75.3506 36.414C75.3506 37.9503 76.5535 39.0476 77.9752 39.0476Z",
    fill: "#91979D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7502 27.6985L51.9766 30.8267L52.7559 32.275L58.5295 29.1469L57.7502 27.6985Z",
    fill: "#91979D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6181 27.6573L76.8389 29.1058L82.6131 32.2333L83.3923 30.7848L77.6181 27.6573Z",
    fill: "#91979D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9137 45.1913C69.6048 45.1913 70.9758 44.1596 70.9758 42.8869C70.9758 41.6141 69.6048 40.5824 67.9137 40.5824C66.2225 40.5824 64.8516 41.6141 64.8516 42.8869C64.8516 44.1596 66.2225 45.1913 67.9137 45.1913Z",
    fill: "#91979D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6137 69.278L83.9932 54.6189L87.3449 51.2556L101.954 65.9264L98.6137 69.278Z",
    fill: "#5D6373"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.895 76.6424L94.6836 65.3929C93.7474 64.4535 93.7474 62.9226 94.6836 61.9832C95.6198 61.0438 97.1454 61.0438 98.0815 61.9832L109.293 73.2327C110.229 74.1721 110.229 75.703 109.293 76.6424C108.356 77.5818 106.831 77.5818 105.895 76.6424Z",
    fill: "#5D6373"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.096 77.3635L90.6723 62.8899C90.3371 62.5536 90.3371 62.0085 90.6723 61.6606L94.3592 57.961C94.6944 57.6247 95.2376 57.6247 95.5843 57.961L110.008 72.4346C110.344 72.7709 110.344 73.316 110.008 73.6639L106.321 77.3635C105.975 77.6998 105.431 77.6998 105.096 77.3635Z",
    fill: "url(#paint0_linear_31762_228260)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4441 7.38403C52.1417 7.38403 39.7402 19.8281 39.7402 35.1831C39.7402 50.5265 52.1417 62.9821 67.4325 62.9821C82.7349 62.9821 95.1364 50.5381 95.1364 35.1831C95.1364 19.8281 82.735 7.38403 67.4441 7.38403ZM67.4441 57.8328C55.1582 57.8328 45.207 47.6851 45.207 35.1715C45.207 22.6578 55.1582 12.5217 67.4441 12.5217C79.7299 12.5217 89.6811 22.6694 89.6811 35.1831C89.6811 47.6967 79.7184 57.8328 67.4441 57.8328Z",
    fill: "url(#paint1_linear_31762_228260)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31762_228260",
    x1: 90.4118,
    y1: 67.6644,
    x2: 110.263,
    y2: 67.6644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8892A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31762_228260",
    x1: 39.7149,
    y1: 35.1891,
    x2: 95.1465,
    y2: 35.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8892A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7686"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGifdark);
export default __webpack_public_path__ + "static/media/empty-gifdark.e35924cc84314b6a21ac4bbc572bba49.svg";
export { ForwardRef as ReactComponent };